import { useMemo } from 'react'

import { InsightsDuplicatesSkeleton } from '@/components/ui'
import { groupDuplicates } from '@/modules/insights/utils'
import {
  DeleteTransactionsDialog,
  useFetchTransactions,
  useInsights,
  useLoadingInsights,
  useLoadingTransactions,
  useProject,
  useTransactions,
} from '@/modules/projects'
import { DuplicateReview, ResolvedPanel } from '../components'

interface DuplicateReviewPageProps {
  slug: string
  groupId: string
}

export function DuplicateReviewPage({
  slug,
  groupId,
}: DuplicateReviewPageProps) {
  const project = useProject()
  const insights = useInsights()
  const transactions = useTransactions()
  const loadingInsights = useLoadingInsights()
  const loadingTransactions = useLoadingTransactions()

  useFetchTransactions(slug)

  const groups = useMemo(
    () => groupDuplicates(insights?.duplicates ?? [], transactions),
    [insights?.duplicates, transactions],
  )

  if (loadingInsights || loadingTransactions || !project) {
    return <InsightsDuplicatesSkeleton />
  }

  const group = groups.find((item) => item.id === groupId)

  return (
    <>
      <DeleteTransactionsDialog />
      {group ? (
        // Keyed so the pager resets the selected row and the mounted PDFs on every move.
        <DuplicateReview
          key={group.id}
          slug={slug}
          group={group}
          worklist={groups}
        />
      ) : (
        <ResolvedPanel slug={slug} worklist={groups} />
      )}
    </>
  )
}
